import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Row,
  Tooltip,
} from "reactstrap";
//Import Images
import bg1 from "../../assets/images/bg-1.png";
import isEmpty from "../../redux/is-empty";
import { subscribe } from "../../redux/subscriberAction";
import Emoji from "./Emoji";

export default function Szection() {
  const dispatch = useDispatch();
  const subscriber = useSelector((state) => state.subscriber.subscriber);
  const loading = useSelector((state) => state.subscriber.loading);
  const errors = useSelector((state) => state.subscriber.errors);

  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [tooltipOpen2, setTooltipOpen2] = useState(false);
  const toggle = () => setTooltipOpen(!tooltipOpen);
  const toggle2 = () => setTooltipOpen2(!tooltipOpen2);
  const [form, setForm] = useState(false);
  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });
  const onSubmit = (e) => {
    e.preventDefault();
    console.log(`form`, form);
    dispatch(subscribe(form));
  };
  return (
    <React.Fragment>
      <section
        className="hero-section-2"
        id="home"
        style={{ background: `url(${bg1}) center center` }}
      >
        <Container>
          <Row className="vertical-content justify-content-center">
            <Col lg={6}>
              <div className="hero-wrapper mb-4">
                <p className="font-20 text-uppercase">እኛ ለእኛ እንበቃለን!</p>
                <h1 className="hero-title mb-4">
                  Track your fundraising in realtime with
                  <span className="text-primary"> Agari.</span>
                </h1>

                <p>
                  There is a new way of fundraising. Agari provides an
                  accountable, secured and open crowdfunding platform that turn
                  compassion into action.
                </p>

                <Tooltip
                  placement="right"
                  isOpen={tooltipOpen}
                  target="apple-tooltip"
                  toggle={toggle}
                >
                  Comming Soon!
                </Tooltip>
                <Tooltip
                  placement="right"
                  isOpen={tooltipOpen2}
                  target="google-play-tooltip"
                  toggle={toggle2}
                >
                  Comming Soon
                </Tooltip>
                <div className="mt-4">
                  <Link
                    to="#"
                    id="google-play-tooltip"
                    className="btn btn-primary  mt-2 mr-2"
                  >
                    <i className="mdi mdi-google-play ml-2"></i> Google Play
                  </Link>

                  <Link
                    to="#"
                    id="apple-tooltip"
                    className="btn btn-success mt-2  mr-2 ml-1"
                  >
                    <i className="mdi mdi-apple ml-2"></i> Apple Store
                  </Link>
                </div>
              </div>
            </Col>

            <Col lg={{ size: 4, offset: 2 }}>
              <Card className="mx-auto p-4 rounded mt-5 mt-lg-0">
                {subscriber ? (
                  <span>
                    {" "}
                    <h1 className="text-center">
                      <Emoji symbol="🙌🏾" />
                    </h1>
                    <h4 className="text-center">Thank you for subscribing!</h4>
                    <h6 className="text-center">See you on our release date</h6>
                  </span>
                ) : (
                  <span>
                    <div className="text-center">
                      <p className="text-muted mb-2 font-13 text-uppercase">
                        Get Notified When We Launch
                      </p>
                      <h5 className="form-title mb-4">
                        Be A Part Of The New Ethiopia
                      </h5>
                    </div>
                    <Form onSubmit={onSubmit} className="registration-form">
                      <FormGroup className="mb-4">
                        <Label className="font-15">Your Name*</Label>
                        <Input
                          type="text"
                          invalid={!isEmpty(errors) && errors.name}
                          className="form-control"
                          name="name"
                          placeholder=""
                          onChange={onChange}
                        />
                        {!isEmpty(errors) && (
                          <FormFeedback>{errors.name}</FormFeedback>
                        )}
                      </FormGroup>
                      <FormGroup className="mb-4">
                        <Label className="font-15">Your Email*</Label>
                        <Input
                          type="email"
                          invalid={!isEmpty(errors) && errors.email}
                          className="form-control "
                          name="email"
                          placeholder=""
                          onChange={onChange}
                        />
                        {!isEmpty(errors) && (
                          <FormFeedback>{errors.email}</FormFeedback>
                        )}
                      </FormGroup>
                      <FormGroup className="mb-3">
                        <Label className="font-15">Your Phone*</Label>
                        <Input
                          type="tel"
                          className="form-control"
                          name="phone"
                          invalid={!isEmpty(errors) && errors.phone}
                          placeholder=""
                          onChange={onChange}
                        />
                        {!isEmpty(errors) && (
                          <FormFeedback>{errors.phone}</FormFeedback>
                        )}
                      </FormGroup>
                      <Button
                        type="submit"
                        color="primary"
                        disabled={loading}
                        size="sm"
                        block
                      >
                        Subscribe{" "}
                        {loading ? (
                          <img
                            alt="loader"
                            src="https://www.francescafurzi.com/images/loaders/dergedcbh.gif"
                            width="30"
                            height="30"
                          />
                        ) : (
                          <i className="mdi mdi-telegram ml-2"></i>
                        )}
                      </Button>
                    </Form>
                  </span>
                )}
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
    </React.Fragment>
  );
}
